// extracted by mini-css-extract-plugin
export default {"category":"OPjHp","criterion":"Nv2-x","interval":"adx1G","summary":"XPbWc"};